import { Col, Image, Row } from "antd";
import { createUseStyles } from "react-jss";
import { _STYLES } from "../common/utils/customStyles";
import { PERMISSION_FEATURES } from "../permissions/types/permission-types";
import ResetPasswordModal from "../resetPassword/resetPasswordModal";
import customerManagementStyles from "./customerManagement-styles";
import CustomerManagementModal from "./modals/customerManagementModal";
import DocumentReUploadModal from "./modals/documentReUploadModal";
import CustomerManagementTable from "./table/customerManagementTable.component";

const {
  textMd1,
  colorText,
  paraLine,
  textSm3,
  colorPrimary,
  w100,
  mb1,
  bgWhite,
  fontBold,
} = _STYLES;
const { welcome, welcomeContent, welcomeTitle, welcomeSub, welcomeIllustration, welcomeBtn } = customerManagementStyles;

const useStyles = createUseStyles({
  textMd1,
  colorText,
  paraLine,
  textSm3,
  colorPrimary,
  welcome,
  welcomeContent,
  welcomeTitle,
  welcomeSub,
  welcomeIllustration,
  welcomeBtn,
  w100,
  mb1,
  bgWhite,
  fontBold,
});

const CustomerManagementComponent = ({
  isCustomerModalOpen,
  toggleCustomerModal,
  actionCellRenderer,
  refreshTable,
  customerTableRef,
  customerModalRef,
  auth,
  isResetPasswordModalOpen,
  toggleResetPasswordModal,
  resetPasswordModalRef,
  isDocumentReUploadModalOpen,
  toggleDocumentReUploadModalModal,
  docReUploadModalRef,
  isViewNICModalOpen,
  setIsViewNICModalOpen,
  selectedNIC,
}) => {
  const classes = useStyles();

  return (
    <Row gutter={[40, 20]}>
      <Col xs={24}>
        <Row gutter={[40, 24]}>
          <Col xs={24}>
            <Row className={classes.welcome}>
              <div className={classes.welcomeContent}>
                <h3 className={classes.welcomeTitle}>Customer Management</h3>
                <p className={classes.welcomeSub}>View and manage all registered customer accounts</p>
              </div>
              {/* Building SVG illustration */}
              <svg className={classes.welcomeIllustration} viewBox="0 0 200 150" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="40" y="38" width="120" height="102" rx="8" fill="white" fillOpacity="0.88"/>
                <rect x="68" y="20" width="64" height="26" rx="4" fill="white" fillOpacity="0.65"/>
                <rect x="54" y="56" width="25" height="20" rx="3" fill="#66CFF0" fillOpacity="0.65"/>
                <rect x="87" y="56" width="25" height="20" rx="3" fill="#66CFF0" fillOpacity="0.65"/>
                <rect x="120" y="56" width="25" height="20" rx="3" fill="#66CFF0" fillOpacity="0.65"/>
                <rect x="54" y="85" width="25" height="20" rx="3" fill="#66CFF0" fillOpacity="0.4"/>
                <rect x="87" y="85" width="25" height="20" rx="3" fill="#66CFF0" fillOpacity="0.4"/>
                <rect x="120" y="85" width="25" height="20" rx="3" fill="#66CFF0" fillOpacity="0.4"/>
                <rect x="87" y="112" width="26" height="28" rx="3" fill="white" fillOpacity="0.5"/>
                <circle cx="107" cy="127" r="3" fill="#66CFF0" fillOpacity="0.9"/>
              </svg>
            </Row>
          </Col>
        </Row>
      </Col>
      <Col xs={24}>
        <CustomerManagementTable
          actionCellRenderer={actionCellRenderer}
          ref={customerTableRef}
        />
      </Col>
      <CustomerManagementModal
        isModelOpen={isCustomerModalOpen}
        toggleModal={toggleCustomerModal}
        cbOnSave={refreshTable}
        isDisabled={!auth[PERMISSION_FEATURES.EDIT]}
        ref={customerModalRef}
      />
      <ResetPasswordModal
        isModelOpen={isResetPasswordModalOpen}
        toggleModal={toggleResetPasswordModal}
        ref={resetPasswordModalRef}
        cbOnSave={refreshTable}
        type="customer"
      />
      <DocumentReUploadModal
        isModelOpen={isDocumentReUploadModalOpen}
        toggleModal={toggleDocumentReUploadModalModal}
        ref={docReUploadModalRef}
        cbOnSave={refreshTable}
      />
      <Image
        style={{ display: "none" }}
        width={200}
        preview={{
          visible: isViewNICModalOpen,
          onVisibleChange: (visible, prevVisible) =>
            setIsViewNICModalOpen(visible),
        }}
        src={selectedNIC}
      />
    </Row>
  );
};

export default CustomerManagementComponent;
